import React from "react"
import { Text } from "theme-ui"
import ReactTooltip from "react-tooltip"

export default function PageNumber({ children, digital, physical }) {
  return (
    <>
      <Text 
        as="span"
        variant="button" 
        data-tip={`D ${digital} • P ${physical}`}
        sx={{ 
          display: "inline",
          whiteSpace: "nowrap",
          mb: 0,
          borderBottom: "1px dashed",
          cursor: "pointer",
        }}
      >
        {children}
      </Text>
      <ReactTooltip effect="solid" className="tooltip" />
    </>
  )
}
